/**
 * Výber zostáv z Tandem Zákazky (KOLO 175) — každý krok sprievodcu parsuje
 * súbor znova, takže ho musí dostať analýza, potvrdenie aj aktualizácia.
 * Bez výberu sa pole neposiela (celý kusovník ako doteraz).
 */
export function pridajVyber(fd: FormData, zostavyVybrane?: string[] | null): void {
  if (zostavyVybrane && zostavyVybrane.length > 0) {
    fd.append("zostavy_vybrane_json", JSON.stringify(zostavyVybrane));
  }
}
